import React, { useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import Content from "../../../components/layout/Content";
import { parseNumToFixed } from '../../../utils/common';

const ResultRow = ({ items }) => {

    const totalSum = useMemo(() => {
        const total = items.reduce((acc, item) => {
            return acc + (parseNumToFixed(item.totalSum) || 0);
        }, 0);
        return parseNumToFixed(total);
    }, [items]);

    if (window.innerWidth > 1024) {
        return (
            <Content>
                <tr key={'result_items'} className="kt-datatable__row">
                    <td width="120px" className="kt-datatable__cell" />
                    <td style={{textAlign: 'left'}} width="165px" className="kt-datatable__cell">
                        <span style={{ fontWeight: 600}}>Итого</span>
                    </td>
                    <td width="165px" className="kt-datatable__cell"/>
                    <td width="auto" className="kt-datatable__cell" />
                    <td style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell"/>
                    <td style={{ textAlign: 'center', fontWeight: 600 }} width="165px" className="kt-datatable__cell">
                        <span>{totalSum}</span>
                    </td>
                    <td align="right" width="180px" className="kt-datatable__cell"/>
                </tr>
            </Content>
        );
    }

    return (
        <tr className="kt-datatable__row">
            <td colSpan="8">
                <div className='mobile_div_flex column padding10px'>
                    <div className='mobile_div_flex column_mobile430px'>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000', fontWeight: 600 }}>Итого</span>
                        </div>
                        <div style={{ width: '100%', textAlign: 'end' }}>
                            <span style={{ color: '#000', fontWeight: 600 }}>{totalSum}</span>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
};

export default withRouter(ResultRow);
